import { Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { optimizeImageUrl } from "@faire/web/common/transform-images";
import { Column, HorizontalLine, Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ContactUsMainBannerDesktop = function ContactUsMainBannerDesktop(_ref) {
  var borderPosition = _ref.borderPosition;
  var _useViewport = useViewport(),
    isDesktopAndAbove = _useViewport.isDesktopAndAbove;
  var imageUrl = optimizeImageUrl({
    url: isDesktopAndAbove ? "https://cdn.faire.com/fastly/4c971e1e45f4e1cb8ad1201d3c6e6f49538e500be7877b00185640facd8bac96.png" : "https://cdn.faire.com/fastly/bc3a24708a6766f52ec6970ec31865c9a2fffec70e38df724c25a2cde12cb251.png"
  }, false);
  return /*#__PURE__*/React.createElement(Wrapper, null, borderPosition === "top" ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Border, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "6x"
  }))) : null, /*#__PURE__*/React.createElement(ColorWrapper, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: imageUrl
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "6x"
  }), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yfjhK+",
    defaultMessage: "Need more help?"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nSILmm",
    defaultMessage: "Share more about your issue, and get in touch with our support team."
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(StyledContactUsButton, {
    source: SelfServeSource.CONTACT_US_FOOTER_BANNER
  }))), borderPosition === "bottom" ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "6x"
  }), /*#__PURE__*/React.createElement(Border, null))) : null);
};
var Wrapper = styled(Column).attrs({
  justify: "center",
  align: "center"
}).withConfig({
  displayName: "ContactUsMainBannerDesktop__Wrapper"
})(["padding:", ";"], getSpacing("7x"));
var ColorWrapper = styled(Row).withConfig({
  displayName: "ContactUsMainBannerDesktop__ColorWrapper"
})(["background-color:", ";width:100%;max-width:1500px;padding:", ";"], Decorative.tint.orange, getSpacing("4x"));
var ImageWrapper = styled(Column).withConfig({
  displayName: "ContactUsMainBannerDesktop__ImageWrapper"
})(["width:50%;"]);
var Border = styled(HorizontalLine).withConfig({
  displayName: "ContactUsMainBannerDesktop__Border"
})(["max-width:1500px;"]);
var ContentWrapper = styled(Column).attrs({
  justify: "center"
}).withConfig({
  displayName: "ContactUsMainBannerDesktop__ContentWrapper"
})(["background-color:", ";"], Decorative.tint.orange);
var StyledContactUsButton = styled(ContactUsButton).withConfig({
  displayName: "ContactUsMainBannerDesktop__StyledContactUsButton"
})(["width:200px;"]);